import { Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../containers/SideBar';
import styles from './styles';

const AdminLayout = () => {
    return (
        <>
            <Typography component="div" sx={styles.layout}>
                <Sidebar />
                <Outlet />
            </Typography>
        </>
    );
};

export default AdminLayout;
